import { StoreNestedFilterExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../models/fact-mapping.interface';
import { FactExtractor } from '../fact-extractor';

export const PERFORMANCE_FACTS: { [factName: string]: FactMappingInterface } = {
	alternativesOneYearBetaSNP500: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['performance'],
				'performance.sleeves',
				[
					{ propertyToCompare: 'sleeveId', comparedValue: 'alternatives', desiredValueExpression: 'sleeveAnalysis.performance.exPostMetrics[0].metrics' },
					{ propertyToCompare: 'name', comparedValue: 'betaSP1Yr', desiredValueExpression: 'metricValue' }
				]
			)
		], betaSP1Yr => betaSP1Yr)
	},
	alternativesThreeYearBetaSNP500: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['performance'],
				'performance.sleeves',
				[
					{ propertyToCompare: 'sleeveId', comparedValue: 'alternatives', desiredValueExpression: 'sleeveAnalysis.performance.exPostMetrics[0].metrics' },
					{ propertyToCompare: 'name', comparedValue: 'betaSP3Yr', desiredValueExpression: 'metricValue' }
				]
			)
		], betaSP3Yr => betaSP3Yr)
	}
};
